import { extractTextFromQuery } from '../../../utils/query';
import { creator_firstName_$ilike_includes, creator_lastName_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  having: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word){
          return {
            ...creator_firstName_$ilike_includes(word)
          };
        }).concat(words.map(function(word){
          return {
            ...creator_lastName_$ilike_includes(word)
          };
        }))
      }
    }
  }
}
